import { render, staticRenderFns } from "./product-brands.modal.vue?vue&type=template&id=01f63b55&scoped=true"
import script from "./product-brands.modal.vue?vue&type=script&lang=js"
export * from "./product-brands.modal.vue?vue&type=script&lang=js"
import style0 from "./product-brands.modal.vue?vue&type=style&index=0&id=01f63b55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f63b55",
  null
  
)

export default component.exports